export const getBannerDimensionsForZone = (zone) => {
    switch (zone) {
        case 'LEADERBOARD_1A':
        case 'LEADERBOARD_1B':
            return { desktop: { width: 632, height: 328 }, mobile: { width: 500, height: 328 } };
        case 'LEADERBOARD_2':
        case 'LEADERBOARD_3':
        case 'LEADERBOARD_4':
        case 'LEADERBOARD_5':
        case 'LEADERBOARD_6':
        case 'LEADERBOARD_7':
            return { desktop: { width: 416, height: 148 }, mobile: { width: 416, height: 148 } };
        default:
            return { desktop: { width: 632, height: 328 }, mobile: { width: 500, height: 328 } };
    }
};
//# sourceMappingURL=getBannerDimensionsForZone.js.map